import type { InputProps as AntdInputProps } from 'antd';
import type { FieldValues, Path } from 'react-hook-form';

import type { ReactNode } from 'react';
import React from 'react';

import { MaskedInput as MaskedInputAntd } from 'antd-mask-input';

type MaskedInputProps<TFieldValues extends FieldValues> = AntdInputProps & {
  id?: string;
  placeholder?: string;
  className?: string;
  addonBefore?: ReactNode;
  maxLength?: number;
  pattern: string;
  name?: Path<TFieldValues>;
  onChange?: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
};

const MaskedInput = <TFieldValues extends FieldValues>(
  props: MaskedInputProps<TFieldValues>
) => {
  const {
    onChange,
    name,
    className,
    placeholder,
    id,
    disabled,
    pattern,
    type,
    addonBefore,
    maxLength,
    onBlur,
    onFocus,
    defaultValue
  } = props;

  if (!name || !onChange) {
    return null;
  }

  return (
    <MaskedInputAntd
      id={id}
      placeholder={placeholder}
      name={name}
      onChange={onChange}
      defaultValue={
        typeof defaultValue !== 'string' ? String(defaultValue) : defaultValue
      }
      addonBefore={addonBefore}
      type={type}
      maxLength={maxLength}
      onBlur={onBlur}
      disabled={disabled}
      onFocus={onFocus}
      mask={pattern}
      className={className}
    />
  );
};

export { MaskedInput };
export type { MaskedInputProps };
